class CalculateConstants {
  SOURCE: string[] = ["ned_1", "ned_2", "globe30"];
  UNIT: string[] = ["meters", "miles", "feet"];
}
export default CalculateConstants;
